module.exports = __webpack_public_path__ + "img/res-bg.6aca8443.png";